export function selectIsLoading(state) {
  return state.global.isLoading;
}

export function selectError(state) {
  return state.global.error;
}
